import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AuthProvider } from './shared/auth/AuthContext';
import { BrandingProvider } from './shared/branding/BrandingProvider';
import { DisplayLanguageProvider } from './shared/language/DisplayLanguageContext';
import { ProtectedRoute } from './shared/auth/ProtectedRoute';
import { HomeRedirect } from './shared/auth/HomeRedirect';
import { Policies } from './shared/auth/accessPolicies';
import LoginPage from './auth/routes/LoginPage';
import TenantSelectPage from './auth/routes/TenantSelectPage';
import ForgotPasswordPage from './auth/routes/ForgotPasswordPage';
import ResetPasswordPage from './auth/routes/ResetPasswordPage';
import AcceptInvitationPage from './auth/routes/AcceptInvitationPage';
import ProfilePage from './auth/routes/ProfilePage';

const AdminApp = lazy(() => import('./admin/AdminApp'));
const ExamApp = lazy(() => import('./exam/ExamApp'));

function Loading(): JSX.Element {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  );
}

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <BrandingProvider>
          <DisplayLanguageProvider>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/select-tenant" element={<TenantSelectPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/exam-taking/*"
                element={
                  <ProtectedRoute requireAnyRole={Policies.candidate}>
                    <ExamApp />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <HomeRedirect />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/*"
                element={
                  <ProtectedRoute requireAnyRole={Policies.staff}>
                    <AdminApp />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Suspense>
          </DisplayLanguageProvider>
        </BrandingProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
